// Far enough that the button only shows once the reader has really left the
// latest message, not while a streaming answer nudges the scroll by a line.
export const SCROLL_TO_LATEST_DELTA = 160

export const distanceFromBottom = ({
	scrollHeight,
	scrollTop,
	clientHeight,
}: {
	scrollHeight: number
	scrollTop: number
	clientHeight: number
}): number => Math.max(0, scrollHeight - scrollTop - clientHeight)

export const isAwayFromLatest = (metrics: {
	scrollHeight: number
	scrollTop: number
	clientHeight: number
}): boolean => distanceFromBottom(metrics) > SCROLL_TO_LATEST_DELTA

// Close enough to the end that scrolling back down resumes following the reply.
export const STICK_TO_BOTTOM_DELTA = 24

// Each frame closes 1 - e^(-dt/tau) of the gap, so the follow eases out at the
// same speed on 60Hz and 120Hz screens.
export const FOLLOW_TIME_CONSTANT_MS = 90

export const followStep = (
	gap: number,
	elapsedMs: number,
	timeConstantMs = FOLLOW_TIME_CONSTANT_MS,
): number => {
	if (gap <= 1) return Math.max(0, gap)
	const eased = gap * (1 - Math.exp(-elapsedMs / timeConstantMs))
	// Whole pixels: WebKit rounds scrollTop, so a fractional step can stall.
	return Math.min(gap, Math.max(1, Math.ceil(eased)))
}

export const nextStickToBottom = ({
	isStuck,
	previousScrollTop,
	scrollTop,
	distance,
}: {
	isStuck: boolean
	previousScrollTop: number
	scrollTop: number
	distance: number
}): boolean => {
	// A clamp from shrinking content also lowers scrollTop, but leaves it at the end.
	if (scrollTop < previousScrollTop - 1 && distance > 1) return false
	if (distance <= STICK_TO_BOTTOM_DELTA) return true
	return isStuck
}
